import React from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { Button } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import UpsertOrganisationComponent from '../../components/organisations/UpsertOrganisationComponent';
import { useHistory } from 'react-router-dom';

const CreateOrganisationPage = (props: any) => {
  const history = useHistory();
  const goTo = (location: string) => {
    history.push(location);
  };

  return (
    <Box>
      <Grid container>
        <Grid item lg={12}>
          <Grid container sx={{ mb: 4 }}>
            <Grid item lg={6}>
              <Typography variant={'h4'}>Create Organisation</Typography>
            </Grid>
            <Grid item lg={6} style={{ textAlign: 'right' }}>
              <Button variant={'outlined'} onClick={() => goTo('/app/organisations')} startIcon={<ArrowBackIcon />}>
                Organisations
              </Button>
            </Grid>
          </Grid>
          <UpsertOrganisationComponent />
        </Grid>
      </Grid>
    </Box>
  );
};

export default CreateOrganisationPage;
